
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Group, GroupUserExternal } from '../../../backend/backendapi';
import { Like } from '../../../../util/Like';
import { paginationOptions, searchOptions, selectOptions } from '../../../../util/vue-good-table';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { ExternalUserSelectModalTabFunctions } from './ExternalUserSelectModalTab';
import { applyGroupSelector, GroupSelector } from '../../util';

@Component({
  components: {
    VueGoodTable,
  },
})
export default class TabExternalUsers<T> extends Vue implements ExternalUserSelectModalTabFunctions {
  @Prop({ required: true })
  readonly groups!: T[];
  @Prop({ default: '' })
  readonly groupSelector!: GroupSelector<T>;
  
  private selectedRows: GroupUserExternal[] = [];

  get columnsConfig(): unknown[] {
    return [{
      label: this.$t('firstname').toString(),
      field: (e: GroupUserExternal) => e.firstName,
    }, {
      label: this.$t('lastname').toString(),
      field: (e: GroupUserExternal) => e.lastName,
    }, {
      label: this.$t('email').toString(),
      field: (e: GroupUserExternal) => e.email,
    }, {
      label: this.$t('salutation').toString(),
      field: (e: GroupUserExternal) => e.salutation,
    }];
  }

  get extractedGroups(): Group[] {
    return this.groups.map(group => applyGroupSelector(group, this.groupSelector));
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get rows(): GroupUserExternal[] {
    return this.extractedGroups.flatMap(e => e.externalUsers);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  get selectOptions(): any {
    return selectOptions(this.$i18n);
  }

  onSelectionChanged(params: { selectedRows: Like<GroupUserExternal>[] }): void {
    this.selectedRows = params.selectedRows.map(e => GroupUserExternal.fromJS({
      firstName: e.firstName,
      lastName: e.lastName,
      email: e.email,
      salutation: e.salutation,
      company: e.company,
      mediaId: e.mediaId,
    }));
  }

  clear(): void {
    this.selectedRows = [];
    (this.$refs.table as VueGoodTable).reset();
  }

  get selectedUsers(): GroupUserExternal[] {
    return this.selectedRows;
  }
}
